import React from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import CustomizerComponent from "@/bit/components/components.customizer-component";

const IconGlyph = dynamic(() => import("@/bit/components/components.icon-glyph"));

const CmsDetailCardList = dynamic(
  () => import("@/bit/components/components.cms-block.cms-detail-card-list"),
);
const CmsSmallFeatureCardList = dynamic(
  () => import("@/bit/components/components.cms-block.cms-small-feature-list"),
);

const COMPONENTS = {
  "cms-detail-card-list": CmsDetailCardList,
  "cms-small-detail-card-list": CmsSmallFeatureCardList,
};

/**
 * Componente que permite crear un carrousel de DetailCard
 */
function CmsCustomizerComponent(props) {
  const { cmsHandler, blockName, cms } = props;
  const activityName = props["activity-name"];
  const componentName = props["cms-component-name"];
  const componentProps = props["component-props"];
  const kind = props["kind"] || "activity";

  if (!cms && !process.env.NEXT_PUBLIC_ASTRO_MAKER) {
    if (!componentName || !COMPONENTS[componentName]) {
      return null;
    }
  }

  return (
    <section id={blockName || ""}>
      {cmsHandler && (
        <span
          className={"element-editable block edit-component"}
          onClick={() =>
            cmsHandler({
              ...props,
              name: "cms-block.cms-customizer-component",
            })
          }
        >
          <IconGlyph id="lapiz-m" height={28} color="white" />
        </span>
      )}
      {componentName && activityName && COMPONENTS[componentName] && (
        <CustomizerComponent
          name={activityName}
          Component={COMPONENTS[componentName]}
          componentProps={componentProps}
          kind={kind}
          componentName="DetailCardList"
        />
      )}
      {/* INJECT_STYLED_JSX_TAG */}
    </section>
  );
}

CmsCustomizerComponent.propTypes = {
  /**
   * {
   *  "info": "Nombre de la CMS-ACTIVITY de la que leerá la info",
   *  "kind": "both",
   *  "beautifulName": "Activity Name"
   * }
   */
  "activity-name": PropTypes.string,
  /**
   * {
   *  "info": "Nombre del componente donde se renderizará la info",
   *  "kind": "both",
   *  "beautifulName": "Nombre del Componente",
   *  "values": "./enums.js:COMPONENTS_KEYS"
   * }
   */
  "cms-component-name": PropTypes.string,
  /**
   * {
   *  "info": "Kind",
   *  "kind": "both",
   *  "beautifulName": "Kind",
   *  "values": "./enums.js:KIND"
   * }
   */
  kind: PropTypes.string,
};

CmsCustomizerComponent.defaultProps = {
  "activity-name": "",
  "cms-component-name": "",
  kind: "activity",
};

export default CmsCustomizerComponent;
